









import {Component, Prop, Vue} from "vue-property-decorator";
import {Getter} from 'vuex-class';
import ThemeArray from "@/components/Theme/ThemeArray";
import Theme from '../Theme/Theme';

@Component
export default class Themes extends Vue {
    @Getter('themes') private themes!: ThemeArray;

    select(theme: Theme) {
        this.$emit('selected', theme);
    }
}
